const { default: CommonServices } = require("./common/common");

class TopicManagementService extends CommonServices {
  constructor() {
    super("/topics");
  }
}

const topicManagementService = new TopicManagementService();
export default topicManagementService;
